import React from 'react'
import { Button, DialogOverlay, DialogOverlayActions, DialogOverlayFooter, Body1 } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import type { Person } from '../types/persons'
import { getExternalBaseUrl } from '../services/url-service'
import { useDataContext } from '../services/data-service'

export default function NotPublished({
  person,
  overlay,
}: {
  person: Person
  overlay: Record<string, unknown>
}): JSX.Element {
  const [t] = useTranslation()
  const baseUrl = getExternalBaseUrl()
  const dataContext = useDataContext()
  const { store: dataState } = dataContext
  const { CF } = dataState
  return (
    <DialogOverlay {...overlay} title={person.name}>
      <Body1>
        {CF
          ? t('ancestors.unavailable.text')
          : t('ancestors.person.not-published', {
              personName: person.name,
            })}
      </Body1>

      <DialogOverlayFooter>
        {CF ? (
          <DialogOverlayActions>
            <Button onClick={overlay.handleClick} data-testid="not-available-close">
              {t('common-ui:close.action')}
            </Button>
          </DialogOverlayActions>
        ) : (
          <DialogOverlayActions>
            <Button
              data-testid="sign-in-button"
              to={`${baseUrl}/auth/familysearch/login?returnurl=${encodeURIComponent(
                // eslint-disable-next-line sonarjs/no-nested-template-literals -- this is simpler
                `${baseUrl}/tree/person/details/${person.id}`
              )}`}
              external
            >
              {t('common-ui:sign-in.action')}
            </Button>
            <Button data-testid="create-account-button" emphasis="high" to={`${baseUrl}/register`} external>
              {t('ancestors.create-free-account.action')}
            </Button>
          </DialogOverlayActions>
        )}
      </DialogOverlayFooter>
    </DialogOverlay>
  )
}
